// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"message-list-item_tableRow__1czRL","icon":"message-list-item_icon__3b3af","tableCell":"message-list-item_tableCell__3Kn82"};